import { AppBar, makeStyles, Toolbar, Grid } from "@material-ui/core";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { FoldersApi } from "../../../api/folders/folders";
import ItemSortSelect from "../../../components/CustomSelect/ItemSortSelect";
import FilterMenu from "../../../components/Menus/PopupMenu/FilterMenu";
import { addQueryParamsToHash, parseFolderIdFromCurrentHash } from "../../../utils/routingHelpers";


const useStyles = makeStyles((theme) => ({
   appBar: {
      marginBottom: theme.spacing(7),
      boxShadow: "none",
      border: "1px solid #d8d8d8",
      height: "64px",
      backgroundColor: "white",
      minWidth: "inherit",
      zIndex: 0
   },
   toolbar: {
      height: "100%",
      whiteSpace: "nowrap"
   },
   contentRight: {
      justifyContent: "flex-end"
   }
}));

export default function ItemsToolbar({ queryParams, history, children }) {
   const classes = useStyles();
   const [availableFilters, setAvailableFilters] = useState({ Users: [], Formats: [], Starred: false });
   const selectedFilters = { creator: queryParams.creator, format: queryParams.format, starred: (queryParams.starred == "true") }
   const sortBy = queryParams.sortBy;

   useEffect(() => {
      const fetchAvailableFilters = async () => {
         const folderId = parseFolderIdFromCurrentHash(history.location.hash);
         const filters = await FoldersApi.fetchAvailableFiltersForFolderItems(folderId);
         filters.data.Data && setAvailableFilters({ ...filters.data.Data, Starred: false });
      }

      fetchAvailableFilters();
   }, []);

   const updateRoute = (sort, filters) => {
      const currentHash = history.location.hash;
      const newHash = addQueryParamsToHash(currentHash, { sortBy: sort, ...filters });
      history.push(newHash);
   };

   const updateSort = (newSortBy) => updateRoute(newSortBy, selectedFilters);

   const updateFilters = (newFilters) => updateRoute(sortBy, newFilters);

   return (
      <AppBar className={classes.appBar} position="static">
         <Toolbar className={classes.toolbar}>
            {children}
            <Grid container className={classes.contentRight}>
               <FilterMenu selectedFilters={selectedFilters} onChange={updateFilters} availableFilters={availableFilters} />
               <ItemSortSelect value={queryParams.sortBy} onChange={updateSort} />
            </Grid>
         </Toolbar>
      </AppBar>
   );
}

ItemsToolbar.propTypes = {
   queryParams: PropTypes.object
};
